import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=3b48a428"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"
import style0 from "./Promo.vue?vue&type=style&index=0&id=3b48a428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports